export const DATE_FORMAT_DAY = 'dd-MM-yyyy'
export const DATE_FORMAT_MINUTE = 'dd-MM-yyyy HH:mm'

export const DATE_FNS_SERVER_DATE = 'yyyy-MM-dd'
